module.exports = __webpack_public_path__ + "static/media/I2space.1f415db8.png";